const TextSelect = ({
  label = 'Unknown Label',
  onChange = null,
  value = '',
  options = [],
  inline = false,
  selectProps = {},
}) => {
  return (
    <div
      className={`px-3 py-2 rounded-xl shadow ${
        inline ? 'flex items-center gap-2' : 'space-y-2'
      }`}
    >
      <label
        htmlFor={label}
        className={`text-gray-700 font-semibold ${!inline && 'block'}`}
      >
        {label}
      </label>
      <select
        name={label}
        className='w-full border-none '
        onChange={onChange}
        value={value}
        {...selectProps}
      >
        {options.map((opt) => (
          <option
            key={opt.key}
            value={opt.key}
            disabled={opt.disabled || false}
          >
            {opt.value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TextSelect;
